<template>
  <div
    :id="markId"
    :class="[
      'filter-container',
      {
        'more-one-line': formNum > 3
      }
    ]"
  >
    <!-- 'p-' + padding, -->
    <el-form
      :ref="refForm"
      :label-width="labelWidth"
      :inline="true"
      :model="model"
      :rules="rules"
      :size="size"
      @submit.native.prevent
    >
      <div :class="posiBtn ? '' : 'filter-banner'">
        <slot name="displayForm" />
        <div
          v-if="$slots.occultationForm"
          :class="[
            'filter-occultationForm',
            { 'filter-occultationForm-hide': !isCollapse }
          ]"
        >
          <slot name="occultationForm" />
        </div>
      </div>
      <!-- <div
        ref="filterBtn"
        :class="posiBtn ? 'position-btns' : 'filter-btns'"
        v-if="showButton"
        :style="{ left: !posiRight ? posi_left : '', right: posiRight ? 0 : '' }"
      >
        <span
          v-if="$slots.occultationForm"
          class="btns-more"
          @click="collapseFilter"
        >
          <i class="el-icon-caret-bottom" :style="{ transform: rotate }"></i>
          {{ filterControlText }}
        </span>
        <div>
          <slot name="controlBtnGroup"></slot>
          <template v-if="paramsButton && !posiBtn">
            <el-button size="mini" @click="saveParam">{{
              $t('components.saveParameters')
            }}</el-button>
            <el-button size="mini" @click="selParam">{{
              $t('components.selectParameters')
            }}</el-button>
          </template>
        </div>
      </div> -->
    </el-form>
    <local-filter-btn
      v-if="type === 'bottom'"
      ref="filterBtn"
      :class="`mt-${padding} pt-${padding}`"
      :occultation-form="!!$slots.occultationForm"
      :show-button="showButton"
      :params-button="paramsButton"
      :model="model"
      @filterAction="filterAction"
      @reset="reset"
      @submit="submit"
      @collapseFilter="collapseFilter"
    />
  </div>
</template>

<script>
import { Format, MessageUtil, request } from '@cndinfo/cube-web-utils'
import '../../../../lib/styles/components/Filter.scss'
import analytics from '../../../utils/analytics'
import localFilterBtn from '../../FilterBtn/index.js'
export default {
  name: 'Filter',
  components: { localFilterBtn },
  props: {
    type: {
      type: String,
      default: 'top'
    },
    // 组件内边距
    padding: {
      type: Number,
      default: 10
    },
    // 参数控制按钮 false  为展示, true 为隐藏
    paramsButton: {
      type: Boolean,
      default: false
    },
    // 按钮保留
    showButton: {
      type: Boolean,
      default: false
    },
    // form的ref名称
    refForm: {
      type: String,
      default: 'filterForm'
    },
    // form的rules
    rules: {
      type: Object,
      default: () => {}
    },
    // form的标题宽度
    labelWidth: {
      type: String,
      default: '85px'
    },
    // form的model
    model: {
      type: Object,
      default: () => {}
    },
    // form的size
    size: {
      type: String,
      default: 'small'
    },
    posiRight: {
      type: Boolean,
      default: false
    },
    posiBtn: {
      type: Boolean,
      default: false
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      posi_left: 0,
      // isCollapse: false, // 是否展开更多查询条件
      // filterControlText: this.$t("components.viewMore"),
      // rotate: 'rotate(0deg)',
      markId: '',
      // 表单树及定位
      formNum: 0
      // 参数
      // paramForm: { name: "" },
      // formRules: {
      //   name: [
      //     {
      //       required: true,
      //       message: this.$t("grid.others.theParameterNameCannotBeEmpty"),
      //       trigger: "blur"
      //     }
      //   ]
      // },
      // dialogVisible: {
      //   save: false,
      //   sel: false
      // },
      // columnDefs: [
      //   {
      //     field: "sParamType",
      //     headerName: this.$t("grid.others.parameterNameKey")
      //   },
      //   {
      //     headerName: this.$t("grid.others.operation"),
      //     width: 40,
      //     cellRendererFramework: TableBtn,
      //     cellRendererParams: {
      //       update: () => {
      //         this.$refs.diaTable.queryTableList()
      //       }
      //     }
      //   }
      // ],
      // reqConfig: {
      //   url: "/paraminfo/page/{pageNo}/{pageSize}",
      //   method: "post",
      //   params: {
      //     pageNo: 0,
      //     pageSize: 10,
      //     sPageCode: localStorage.getItem("menuId")
      //   },
      //   keyword: "sParamType",
      //   dataFormat: {
      //     key: "content",
      //     total: "totalElements"
      //   }
      // },
      // saveParamRequest: {
      //   startTime: 0,
      //   endTime: 0
      // },
      // selectParamRequest: {
      //   startTime: 0,
      //   endTime: 0
      // }
    }
  },
  // watch: {
  //   "dialogVisible.save": function (value) {
  //     this.initSaveParamRequest(value)
  //   },
  //   "dialogVisible.sel": function (value) {
  //     this.initSelectParamRequest(value)
  //   }
  // },
  computed: {
    // 表单类名
    formClass() {
      return `el-form-w${this.labelWidth.substr(0, this.labelWidth.length - 2)}`
    },
    filterControlText() {
      return this.isCollapse
        ? this.$t('components.collapse')
        : this.$t('components.viewMore')
    },
    rotate() {
      return this.isCollapse ? 'rotate(180deg)' : 'rotate(0deg)'
    }
  },
  created() {
    // 设置独有id
    this.markId =
      'filter' + new Date().getTime() + Math.ceil(Math.random() * 10000)
  },
  methods: {
    filterAction(value, type) {
      this.$nextTick(() => {
        this.$emit('action', value)
      })
      if (type === 'confirm') {
        try {
          this.selectParamRequest.endTime = new Date().getTime()
          const operateTimeCost =
            this.selectParamRequest.endTime - this.selectParamRequest.startTime
          const analyticsInstance = analytics.getAnalyticsInstance(this)
          analyticsInstance.reportEvent('advanced_search_select_params_click', {
            operate_time_cost: operateTimeCost
          })
        } catch (error) {
          console.log(error)
        }
      }
    },
    // 保存参数键盘事件
    // tabCell (e) {
    //   e.keyCode === 13 && this.handleConfirm()
    // },
    // 确认选择参数
    // onSelect (option, type) {
    //   this.dialogVisible.sel = false
    //   console.log("option--", option, this.model)
    //   type === "confirm" &&
    //     Object.assign(this.model, JSON.parse(option[0].sParamValue))
    //   this.$nextTick(() => {
    //     this.$emit("action", JSON.parse(option[0].sParamValue))
    //   })
    //   try {
    //     this.selectParamRequest.endTime = new Date().getTime()
    //     const operateTimeCost =
    //       this.selectParamRequest.endTime - this.selectParamRequest.startTime
    //     window.collectEvent("advanced_search_select_params_click", {
    //       operate_time_cost: operateTimeCost
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    // 确认保存
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            sPageCode: localStorage.getItem('menuId'),
            sParamType: this.paramForm.name,
            sParamValue: JSON.stringify(Format.filterObj(this.model))
          }

          request({
            url: '/paraminfo/add',
            method: 'POST',
            data: params,
            noLoading: true
          })
            .then((res) => {
              this.$refs.form.resetFields()
              this.handleClose('save')
              MessageUtil.success(this.$t('tips.saveSuccess'))
              this.saveParamRequest.endTime = new Date().getTime()
              try {
                const analyticsInstance = analytics.getAnalyticsInstance(this)
                analyticsInstance.reportEvent(
                  'advanced_search_save_params_click',
                  {
                    is_success: 'true',
                    operate_time_cost:
                      this.saveParamRequest.endTime -
                      this.saveParamRequest.startTime
                  }
                )
              } catch (error) {
                console.log(error)
              }
            })
            .catch((err) => {
              console.log(err)
              this.saveParamRequest.endTime = new Date().getTime()
              try {
                const analyticsInstance = analytics.getAnalyticsInstance(this)
                analyticsInstance.reportEvent(
                  'advanced_search_save_params_click',
                  {
                    is_success: 'false',
                    operate_time_cost:
                      this.saveParamRequest.endTime -
                      this.saveParamRequest.startTime
                  }
                )
              } catch (e) {
                console.log(e)
              }
            })
          // apiList
          //   .postList(params, "/paraminfo/add")
          //   .then((res) => {
          //     this.$refs.form.resetFields()
          //     this.handleClose("save")
          //     MessageUtil.success(this.$t("tips.saveSuccess"))
          //     this.saveParamRequest.endTime = new Date().getTime()
          //     try {
          //       const analyticsInstance = analytics.getAnalyticsInstance(this)
          //       analyticsInstance.reportEvent(
          //         "advanced_search_save_params_click",
          //         {
          //           is_success: "true",
          //           operate_time_cost:
          //             this.saveParamRequest.endTime -
          //             this.saveParamRequest.startTime
          //         }
          //       )
          //     } catch (error) {
          //       console.log(error)
          //     }
          //   })
          //   .catch((err) => {
          //     console.log(err)
          //     this.saveParamRequest.endTime = new Date().getTime()
          //     try {
          //       const analyticsInstance = analytics.getAnalyticsInstance(this)
          //       analyticsInstance.reportEvent(
          //         "advanced_search_save_params_click",
          //         {
          //           is_success: "false",
          //           operate_time_cost:
          //             this.saveParamRequest.endTime -
          //             this.saveParamRequest.startTime
          //         }
          //       )
          //     } catch (e) {
          //       console.log(e)
          //     }
          //   })
        }
      })
    },
    // 保存参数
    // saveParam () {
    //   this.dialogVisible.save = true
    // },
    // // 选择参数
    // selParam () {
    //   this.dialogVisible.sel = true
    // },
    // handleClose (type) {
    //   this.dialogVisible[type] = false
    // },
    // 初始化按钮位置
    initBtnPosi() {
      // 当前filter对象
      const curFilter = document.getElementById(this.markId)
      // console.log('curFilter--', curFilter)
      if (curFilter) {
        const row_width =
          curFilter.getElementsByClassName('el-row')[0].offsetWidth
        const col_list = curFilter.getElementsByClassName('el-col')
        const col_list_legth = col_list.length
        const col_total_width = col_list[0].offsetWidth * col_list_legth
        if (row_width - col_total_width > 172) {
          this.formNum = col_list_legth
          if (this.formNum < 4) {
            this.posi_left = col_list[0].offsetWidth * this.formNum + 20 + 'px'
          }
        } else {
          this.formNum = 4
        }
      }
    },
    // 展开关闭更多查询条件
    collapseFilter() {
      // 关闭之前查询一下
      let searchParamsMin = 0
      let searchParamsMax = 0
      const filterBanner = document.getElementsByClassName('filter-banner')
      if (!this.isCollapse) {
        if (filterBanner[0]) {
          searchParamsMax = filterBanner[0].getElementsByClassName(
            'form-item-container'
          ).length
          const filterMore = filterBanner[0].getElementsByClassName(
            'filter-occultationForm '
          )
          if (filterMore[0]) {
            searchParamsMin =
              searchParamsMax -
              filterMore[0].getElementsByClassName('form-item-container').length
          }
        }
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.isCollapse = !this.isCollapse
      if (this.isCollapse) {
        try {
          const analyticsInstance = analytics.getAnalyticsInstance(this)
          analyticsInstance.reportEvent('advanced_search_show_more_click', {
            search_params_min: searchParamsMin,
            search_params_max: searchParamsMax
          })
        } catch (e) {
          console.log(e)
        }
        // this.$refs.filterBtn.filterControlText = this.$t("components.collapse")
        // this.$refs.filterBtn.rotate = "rotate(180deg)"
        // this.filterControlText = this.$t("components.collapse")
        // this.rotate = "rotate(180deg)"
      } else {
        try {
          const analyticsInstance = analytics.getAnalyticsInstance(this)
          analyticsInstance.reportEvent('advanced_search_show_less_click')
        } catch (e) {
          console.log(e)
        }
        // this.$refs.filterBtn.filterControlText = this.$t("components.viewMore")
        // this.$refs.filterBtn.rotate = "rotate(0deg)"
        // this.filterControlText = this.$t("components.viewMore")
        // this.rotate = "rotate(0deg)"
      }
      this.$emit('callBack', this.isCollapse)
    },
    //
    submit() {
      this.$emit('submit')
    },
    // 重置查询表单
    reset() {
      this.$refs[this.refForm].resetFields()
      this.$emit('reset')
    },
    validate() {
      let flag = false
      this.$refs[this.refForm].validate((valid) => {
        flag = valid
        return valid
      })
      return flag
    }
    // // 初始化统计保存按钮的时间
    // initSaveParamRequest (value) {
    //   if (value) {
    //     this.saveParamRequest.startTime = new Date().getTime()
    //     this.saveParamRequest.endTime = 0
    //   }
    // },
    // initSelectParamRequest (value) {
    //   if (value) {
    //     this.selectParamRequest.startTime = new Date().getTime()
    //     this.selectParamRequest.endTime = 0
    //   }
    // }
  }
}
</script>
